
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexRNoieDjxtwzWNlhHXBA9RJKl_RgW3nBOG_ID4oOIgKEMeta } from "/azp/agent/_work/5/s/frontend/pages/user/index.vue?macro=true";
import { default as index2vZvGO39EbpmjlptVrV8ho3FKy2iWLnSd9nfvvYDM9gMeta } from "/azp/agent/_work/5/s/frontend/pages/user/downloads/index.vue?macro=true";
import { default as delegate_45accountQNNN6hingKeuqnHTTEa5f_91K5iiH8WiwpsdErlhqloMeta } from "/azp/agent/_work/5/s/frontend/pages/user/delegate-account.vue?macro=true";
import { default as indexh7G4BSFXuXqHvROXeCfg5Rk1ebrdb27TtiJ2L6upp8AMeta } from "/azp/agent/_work/5/s/frontend/pages/user/account-details/index.vue?macro=true";
import { default as indexx7Dc9uuS4_jObW29lrxEGaWGenPVzenrSaKoMdYlKUEMeta } from "/azp/agent/_work/5/s/frontend/pages/user/change-password/index.vue?macro=true";
import { default as indexU5Or0W2YSSuoLG3BGTENSrQqdOWVZeMGPn53Unx_JzkMeta } from "/azp/agent/_work/5/s/frontend/pages/user/platform-notifications/index.vue?macro=true";
import { default as user2Nytptzob8KasznEl_3yq4tRyuqCqFKWNPqwf_oRGyAMeta } from "/azp/agent/_work/5/s/frontend/pages/user.vue?macro=true";
import { default as addvNXXIE9tRznQaRkoppkK98ylLAYVId4zf8GSpzEttpIMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/jobs/add.vue?macro=true";
import { default as index9vGLtIZATMmq7sI0BQA1NFYbZLwu1uQ2B5buQkCyRYUMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/jobs/index.vue?macro=true";
import { default as _91UUID_93YNKImdX4CdZ1otEN1MLAbclH0uCdR2OytsdT5Aa7Es8Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/jobs/[UUID].vue?macro=true";
import { default as _91_91id_93_93dvqaRNY_UgGZJgmNCugI5zbe2tD1CVytcvszjlwUgDYMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/jobs/history/[[id]].vue?macro=true";
import { default as jobs2AmrIzbHe3CccsP_4J8CRBL7whM5GEQhTr0cuPD_4l4Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/jobs.vue?macro=true";
import { default as indexcKx4CMg8WrkHFGw3jKu0wlJS3exBNf7hTS9YFqSI0QAMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/index.vue?macro=true";
import { default as addqSC6yKx30osAyxBpQ6wAKJ85BY1eRZ8QcnrSQRM_MVsMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/roles/add.vue?macro=true";
import { default as _91ID_938zNkK8nWBlueyPQ4CQdUdoA7jwU6zHjwhVO5GnjExq0Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/roles/[ID].vue?macro=true";
import { default as index9D8JrX1hZQ3bMh2RymBJaeJ23Xe8KVzyxdVFmeZ_RH4Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/roles/index.vue?macro=true";
import { default as addiN1GAVDpsry_wqx0Bk4jBwjAfq_U_M8nNYDGWMhRvvUMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/roles/authorizations/add.vue?macro=true";
import { default as _91ID_93JXESyaVLqP5f4sN7pu05l2bWMoEazl4702DKiG9JwXMMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/roles/authorizations/[ID].vue?macro=true";
import { default as rolesWnrNzNfpYnes6Pzig18jobei_xElUAV0p3OenML7CX0Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/roles.vue?macro=true";
import { default as indexmv2EPZ_DIG20SW3c25i1XjRilT5PV1CgK8GnWJLGbiwMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/entity/[tab]/index.vue?macro=true";
import { default as entity6Swk4EBXLRdlo5OwXtlmMAYVLfqra_uqY3a_i9uIJGUMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/entity.vue?macro=true";
import { default as addvujJRL0nFiTbkMaNbICr4Y756r2Ns8MFpf5NxNUALY4Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/dataset/add.vue?macro=true";
import { default as indexAman397ehQ0ZlcSA1pVz86eNXXuKHcqD24vwBTRAYnQMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/dataset/index.vue?macro=true";
import { default as _91UUID_93zWpQeoR2wFDn4XsNOFjC4E9ejMpmHwjSE7_oMiwsaTYMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/dataset/edit/[UUID].vue?macro=true";
import { default as _91name_93lxaaw6IbOAB1TJpseOZIWL6Bw_OTLOhWRjhrM37__MoMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/dataset/details/[UUID]/[name].vue?macro=true";
import { default as addEboC7PI18SlkNIg65wxm4Sm35BT40TTXpLgYAJUUPYkMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/dataset/credentials/[UUID]/add.vue?macro=true";
import { default as index_yUpiv0gBNmgKwtxf_jrt10QxYO8VfukgX75L62jjFgMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/dataset/credentials/[UUID]/index.vue?macro=true";
import { default as _91_91name_93_93IisvMysaNzQwbTVJjg_9oSmXQ9gxYISVCkp1Eyq3GIgMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/dataset/manage/[[UUID]]/[[name]].vue?macro=true";
import { default as _91credentialUUID_93d26J_uahj8_u23OvB2wJWaya5_pqqHanauE5QMh0Dk4Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/dataset/credentials/[UUID]/[credentialUUID].vue?macro=true";
import { default as datasetPK5C3zZg4eY0i_XYMJgb0ZMfmWi9OoWhIFJCVSWeXcwMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/dataset.vue?macro=true";
import { default as index1fbB9nvIZeilsk6uV0nu_sgKxC5YoBpsqXJTqq3DqGYMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/objects/index.vue?macro=true";
import { default as _91UUID_93WSX0xY7oHx_Elstuyeu9cBRqPtiQZZGI7TRsk937OXQMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/objects/overview/[UUID].vue?macro=true";
import { default as addRIqYDPseGD3rMv7GIvTTm1RsoR2I99UFyTxy0hOaNwwMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/records/add.vue?macro=true";
import { default as _91_91recordUUID_93_93tJlJH19SPPnHHAVwEqcS2CbJHDYmRsMFeSeTWH8Mb8UMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/records/[[recordUUID]].vue?macro=true";
import { default as recordsIP6lT4KG6wYN14kf4SJT0dx8qg1YEk4I7eCxwRHGqfEMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/records.vue?macro=true";
import { default as _91_91templateUUID_93_93IRnPlvovuqlLUn9qvpZC4Av3mtfq4vMcKWpEy_GM9HgMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/templates/[[templateUUID]].vue?macro=true";
import { default as templatesYM7Kmw7QHY3rJ3KorkTSHJ9ufA0Oc3nY55nOyhYnincMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/templates.vue?macro=true";
import { default as indexOUoO3YwgTQGeu4_L8qK7pVQcNm4y3Z5k2PZNSuBR_2oMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/display/index.vue?macro=true";
import { default as _91_91tab_93_936ST98Z_HcGGXR_khGG8j8cFGrPPI6tMo_CuMUQfQSjcMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/display/[recordUUID]/[[tab]].vue?macro=true";
import { default as _91recordUUID_93NVq3CiQkicBzwAAn6WqY6giGiPOjxVvYLcNnOPPJEroMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/display/[recordUUID].vue?macro=true";
import { default as indexP_tLicQLB1ereKukznm26IfePVZ_CvZt_NVFy_K2WPYMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/rest-api-keys/[[UUID]]/index.vue?macro=true";
import { default as rulesP2PO_I57GKNeWCeMlCEHGf1PBNE2JtmDphYcGe8bfesMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/rest-api-keys/[[UUID]]/rules.vue?macro=true";
import { default as objectsFn3bcxWWAU6sGXacOYbxW8ZI9KvIvP2I9_Z8EufbyjEMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/objects.vue?macro=true";
import { default as indexTugHtjWW3xpflQnOn5N2O_1sGlg_f9VAaFqski2_s3sMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/wizards/index.vue?macro=true";
import { default as _91UUID_93vl1VekD6EwEaj342bFmPEquMOBm7LUOFDIUvkzH6j2gMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/wizards/[UUID].vue?macro=true";
import { default as add_45wizard_XNJqVfTnTB8cS4Ocoj97yt7OQzZPa3DSlzo3uF0jOgMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/wizards/add-wizard.vue?macro=true";
import { default as _91UUID_93c0mcjE0rH9UBWvgtUu6KFCR_QshDpx2yQaAoM5Jza8EMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/wizards/manage/[UUID].vue?macro=true";
import { default as wizards_VEZLNBUB8BJkdjLRsRb6u_iXz16jhv_d3WZDGCbpZIMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/wizards.vue?macro=true";
import { default as indexA2HWu4wRpWCcM4KSJjbKyaCeTZsWSSR9mw4YVJ_TF1UMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/cron-jobs/index.vue?macro=true";
import { default as _91name_934J7TxSYKvz_acD29Zoo7J_eX2SX6dwC1UaoThVuRC1MMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/cron-jobs/[name].vue?macro=true";
import { default as cron_45jobsDG7bAZ8VTwlb2M8Hwbg0QwzM_qCnIz1c_0mKd0FZkCwMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/cron-jobs.vue?macro=true";
import { default as addPhk_vgs0eczAastmm_38wCfSJdDvpUxQ1k6JFMmQZvMMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/languages/add.vue?macro=true";
import { default as indexLkpDYBGORaAiRdOKtEhAXO0dOldKZrQqv6FnNXwmm3EMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/languages/index.vue?macro=true";
import { default as addisJlyRLD5prmgu_lK6hqAbtlglISRivlJ9luPtGVW6oMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/languages/label-groups/add.vue?macro=true";
import { default as index85OVl6qADQur4VZo7jAy1_tQwUVsKsfnkTLtqacw2_YMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/languages/label-groups/index.vue?macro=true";
import { default as _91labelGroupUUID_93F4PkBOH4_sc6U_ZSrJ2p2YlN7gp3wILgmOgofq3uWQYMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/languages/label-groups/[labelGroupUUID].vue?macro=true";
import { default as label_45groupssNrVO3ocLl5l0KknxiN8L_Bmn06aec2wbNwAfVPQoIAMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/languages/label-groups.vue?macro=true";
import { default as indexMYMkJHs6T_GRk0U8wQX_SYrHX0ez7wxJJGV8r3RBJZcMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/languages/[languageUUID]/labels/index.vue?macro=true";
import { default as _91labelUUID_93ClYUM5IEk0gzNXuD9Atci1mRjY4aQ4xv6Ka33g7h5EIMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/languages/[languageUUID]/labels/[labelUUID].vue?macro=true";
import { default as create_45labelirfdUiLvG5dEl9KVplHmCXa1gs8EHCOxlTpIn_uI75oMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/languages/[languageUUID]/labels/create-label.vue?macro=true";
import { default as labels9thjMYuwYHmL2LBroacG6sf8eioCuYeXcAHfrs0CxdMMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/languages/[languageUUID]/labels.vue?macro=true";
import { default as edit_45languageuxESvwvhIZTkT_xFVgSDGyd_mpqbLko4WfBNWF7sH1YMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/languages/[languageUUID]/edit-language.vue?macro=true";
import { default as languageszFudX7xjkcI3mXIXQFCS5jZzUVu6yIEhkay0PBz9adIMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/languages.vue?macro=true";
import { default as add4c2mBITcQNX6XfdJiFRKkHa1NyceAU5q04PX29srUj8Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/dashboards/add.vue?macro=true";
import { default as indexbEFyJQ7tUnZnonnmjjaBYNkvM4k1gHz65E7MVHeA_noMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/dashboards/index.vue?macro=true";
import { default as _91UUID_93dlXwHwUjULRwg4mlfQtw13mt3Nl9JxArQokCR7FH_C0Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/dashboards/[UUID].vue?macro=true";
import { default as indexpyK__jwvqPvF78kDCAQtDmof71GmJ79lZyiJhvKrnd4Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/dashboards/design/index.vue?macro=true";
import { default as indexrT_HM4OmaygpFJO_auYTqk9zmlHvKRBlLyL_LzBMWRMMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/dashboards/design/[UUID]/index.vue?macro=true";
import { default as mock_45dataomORC0q1pdCJZVqHTACwMeNhpc_o7YBb_EwbcA_0J2wMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/dashboards/design/[UUID]/mock-data.js?macro=true";
import { default as _91widgetUUID_93pV_gD2C4xfABQhmwjhLsLqEqvEQ5RdxaGyM7UvXcSz0Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/dashboards/design/[UUID]/[widgetUUID].vue?macro=true";
import { default as _91UUID_93_TuYyg0y6siF9Qh8XWbgOkwtKY3Oqzs5eGxjPCGKm1EMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/dashboards/design/[UUID].vue?macro=true";
import { default as designfBUB7IoJewGRJpjejMU7hqMHAJaLrdzlHsyE1vDUyDAMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/dashboards/design.vue?macro=true";
import { default as dashboardsxLoXfrCyRXSFKe1Fis1WU5_2fCcM8TYsp761w57SKb0Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/dashboards.vue?macro=true";
import { default as sql_45editorGv252Yd1oTLaRzo_k9NZYC1EQqyFMHwYbxLDZB_grQEMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/sql-editor.vue?macro=true";
import { default as index_HXzbRG6VErQ_9A9UjdTYaSn5Ba_tsRJH0sMEtaXycsMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/user-feeds/index.vue?macro=true";
import { default as _91UUID_93KhaLvwxt7SAVI2rPOxpsmc7OQKatpxWbXAGjNEFeRVMMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/user-feeds/[UUID].vue?macro=true";
import { default as add_45feedi4Kp_rd29ThA0YCFQoylMHvdN5_OBn1uLvTaftKrLrMMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/user-feeds/add-feed.vue?macro=true";
import { default as user_45feedsPgNiHz8XNomw1JT4howk76_QRgGxCBNF6LdHu73li2MMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/user-feeds.vue?macro=true";
import { default as indexoULsjGS7JrhWzeX0s5wQkQkKpIhBkK2dH8AQ6PXfU28Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/work-flows/index.vue?macro=true";
import { default as _91id_93pf3BFPZ_ito9xd4IHlYW5ji3eYyTTs7lZcdgjuyFjQsMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/work-flows/design/[id].vue?macro=true";
import { default as _91_91id_93_93P7nkJSeEPz9QmbtH5njigWFJZJCkbvQjlJbfp_1fiHQMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/work-flows/manage/[[id]].vue?macro=true";
import { default as work_45flowsYyTrtRl_b43JsTO6ygzUCRdM5YiOJ7QrBXWwsWxyCfUMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/work-flows.vue?macro=true";
import { default as audit_45trailGevxDmgx1XwlcQ8w_7CD3j51m_fYiya9kd9sq84nBKQMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/audit-trail.vue?macro=true";
import { default as index7ETKlhrfgmRgWhpJQfmcY6H6KMAuj6fxe4QSQeHCajMMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/data-export/index.vue?macro=true";
import { default as data_45exportd4RW04ms06dUsoaNd0UP5gvwuu_A64h1bjYWT6mishAMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/data-export.vue?macro=true";
import { default as indexnyrpwPKH2KNZj1YxUxagJZaYG5_IKnT_9J0PNdDSaUwMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/data-models/index.vue?macro=true";
import { default as _91UUID_93UmaqTS6busKkhWhRbRdDvLtwEkMgIGfFkspcgVwIpfEMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/data-models/[UUID].vue?macro=true";
import { default as add_45data_45modelI8pc4YnOhHkVgIeRHPATYAjOXtH2jj8_fLw8_KbmHBAMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/data-models/add-data-model.vue?macro=true";
import { default as import_45data_45model0CFYYjXXwlwd__Ym_87_RgljngRbURYtjufJVhnTh_QMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/data-models/import-data-model.vue?macro=true";
import { default as _91objectUUID_93nnJm81c4Bbi1eltBHkUILL3gSKdwi78S2QmJ_5tg_HwMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/data-models/change-log/[objectUUID].vue?macro=true";
import { default as data_45modelsNSxGK5ot0PY4pnegtIzAEU46bZ8uKmVXmzTxrEYVR_sMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/data-models.vue?macro=true";
import { default as debug_45tracefMlSw0UHlAWLMpBIWFta8diWTUu8f7aDPSe8tDrMf38Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/debug-trace.vue?macro=true";
import { default as indexs5xxRCE00jYMFdyXlyTNTUYmNI4lhI1x4wlq3cT_GDkMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/maintenance/index.vue?macro=true";
import { default as _91UUID_93_wlGKsIITQxpMhdCno2Sol00YniPj_TWYH6DnBt9WZAMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/maintenance/[UUID].vue?macro=true";
import { default as add_45screenuu1jKHpPzXvGISP00ZaB814zQB_1_651i6WZQWb3fE0Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/maintenance/add-screen.vue?macro=true";
import { default as maintenancebYg3yb2aw6m2zugO_UYsL04yOdFm4WJEFtO4kMWlGEYMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/maintenance.vue?macro=true";
import { default as indexYpSNZQXVv5ScoT3INL2EU_pH3QgU1fffpfDCSyJopj0Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/action-flows/index.vue?macro=true";
import { default as addgcA_nCOTumD9JF0EYDBT6rbemsIlSXjA7d5_u5OG0iUMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/action-flows/manage/add.vue?macro=true";
import { default as _91id_931rSFjAkZ24S9ZbtZFSDDUW2WvFENbPvqFRUXim22zhQMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/action-flows/design/[id].vue?macro=true";
import { default as _91id_931JGK86V1BaWzWlZNf_oNWFochr6uPG0qg6jg1LqLJqEMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/action-flows/manage/[id].vue?macro=true";
import { default as index6GevRlURaVZGjVFhnm6Zt4RCnyc7NyRQIR78dyVFUzMMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/action-flows/history/[id]/index.vue?macro=true";
import { default as _91historyUUID_93RNirVPwuSJV0UmcoOlaXHN0IR1I_hM5a6aZtPzhVXdUMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/action-flows/history/[id]/[historyUUID].vue?macro=true";
import { default as action_45flows64ryCJPiq2zjDKmOGQZL64YDUjL7rjwSmYjLNC7k4DMMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/action-flows.vue?macro=true";
import { default as addyK2ZEJnng5tNfx6_iW87fUyFg5ABzSDwer7KlL1DR7MMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/applications/apps/add.vue?macro=true";
import { default as index34E95HFDGIqf7EmzNPYUcEh_H6g0Fr_tbDVaiD1G0lwMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/applications/[tab]/index.vue?macro=true";
import { default as addw9jiDVPQspc0H0M6K3LKSiapwJFqADR1QqjBy80DnXUMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/applications/categories/add.vue?macro=true";
import { default as _91UUID_934ti1n1XX4IdNo5yEJoBGYoncNhkizewTtp_gdvfxSj4Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/applications/apps/manage/[UUID].vue?macro=true";
import { default as _91_91UUID_93_93jKuwNtiD5j0Dmj7HQprCDzLQlFhbvVBu_51tjJIjfOQMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/applications/menus/manage/[[UUID]].vue?macro=true";
import { default as addLdqkJWVf8fNOF7sSdtTrbWvY0WrSsfpb3cxbkdcF90UMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/applications/solution-categories/add.vue?macro=true";
import { default as _91_91ID_93_93mu0dXN1n61XVnQm897LExvLN0X91xmyyLMJ5sjFN8fMMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/applications/categories/manage/[[ID]].vue?macro=true";
import { default as _91_91UUID_93_93_Ez6txXFmKzmta4Wx8wAWb_69LZ_TSC_cRLu7ZGtLQsMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/applications/solution-categories/manage/[[UUID]].vue?macro=true";
import { default as applicationskh22bunxzIE0Y2gTOnRUJHstAs3Ol0KlP1IDvsWlklAMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/applications.vue?macro=true";
import { default as addtsKeG5nfJTeRb2UmeKeElBcX_psAVp6yW7Cjf7qgRo4Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/add.vue?macro=true";
import { default as index6_nf_B4vGaJlF8PogCJZOM4Il5apdh3Ip6NWkPg6NgIMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/index.vue?macro=true";
import { default as kpisqvZidRJlbbZgufEMmELrurcI9qGz5JBZ4qxsOjnF80YMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit/kpis.vue?macro=true";
import { default as settingsJtrgUnf2myWT_qaAfDBPTpV87y3yX6LEufJ6dbP4jw4Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit/settings.vue?macro=true";
import { default as developerajiQjqr0aXL4xx7GeikQnKrsfzF0uEyNcnRESxFeoNQMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit/developer.vue?macro=true";
import { default as indexiW6G2zsA794AdqQ3qiXdJle8ZM8GjerXChiZvcbv7rwMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit/rest-apis/index.vue?macro=true";
import { default as customize_45fieldsPQZAJkiBjkhIUvWPmpokRZR2xsvquTCthjBPPMykmDcMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit/customize-fields.vue?macro=true";
import { default as indexqsrRlM3XZW0cduF25uta08lUs9Zt8xApRZLPEQ8G3nUMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit/rest-apis/[restUUID]/index.vue?macro=true";
import { default as rulesesZBQ__7_j7N4B_MA_X_tO8Pg68__mXDmID_JAnQuZwMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit/rest-apis/[restUUID]/rules.vue?macro=true";
import { default as editPEheHjtNAb3CCY6Ry42kCzpyie1zYCdgEisHMKH_v5gMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit.vue?macro=true";
import { default as _91_91state_93_93KdKl3zTpO2gxY9bQcd3Naj1hJ8a_jH8aToH2D3r2gDQMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/overview/[[state]].vue?macro=true";
import { default as overviewYY77zh0G3_TIl6_CJt_DIVLdQq9sVLnGx2TbTBfS9RgMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/overview.vue?macro=true";
import { default as changelog4dE7Exywwz8qBCHIMg1alwvPt4r5qzBC3qAirs_16RAMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/changelog.vue?macro=true";
import { default as whitelistingkRlWl4xk8RXEom5CiffKOiAiAcCS7f_5eG_dYIDPP0sMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/whitelisting.vue?macro=true";
import { default as notificationsK5HgC_zSayUQpJZadIfxqq0ZFJ_OCDgXVOp0vkBTCsYMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/notifications.vue?macro=true";
import { default as _91UUID_93C7YHZhnuGL6yZ_ZRfLwwWqkgicEXAUWQ7Eo7Q7C3itYMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID].vue?macro=true";
import { default as businessrulesqRR6wdEsuWJCMHSuIP8QKEPslPRCtS2DDanc_hO8va4Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/businessrules.vue?macro=true";
import { default as indextobQ_GVjydNdjOqmHBWwFIFqHi0KW81D25LgwAKSglQMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/external-apis/index.vue?macro=true";
import { default as external_45apisVSKp2vduHbAbQyk27LJTKumiLBp6s_EB0kie0vsWrbUMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/external-apis.vue?macro=true";
import { default as _91_91notificationUUID_93_93GRYtJZPMixj5PcY02q9ltnls5mQU4AOEQgrhCnfAgU4Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/notifications/[[UUID]]/[[notificationUUID]].vue?macro=true";
import { default as notificationsy1ls3Vw31MKOKrXFksOWCJoYeCdmRALoeukGv3xUN64Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/notifications.vue?macro=true";
import { default as indexnbtpESt2FvYkthylaOuNCW5F_85x7izymW7YN3KYt7kMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/package-market/index.vue?macro=true";
import { default as indexZdnETJ5vmhuc0QBImoEOeavUV8jas0KPdhhISG6iW_kMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/package-market/[packageUUID]/index.vue?macro=true";
import { default as indexzfdbuKXfR_0L_OyeF0JtuAs7mPnq6IKScUucALMn9tcMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/package-market/[packageUUID]/details/index.vue?macro=true";
import { default as _91releaseUUID_93cG_0Hl_A3WjyR5cg33q3iBuPc_ZRY2KpMT9bRpYzGDoMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/package-market/[packageUUID]/details/[releaseUUID].vue?macro=true";
import { default as package_45marketqS3CBBPmxBJcdOowVlD3wjrlJih9uKjI1rqeOAd6jGAMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/package-market.vue?macro=true";
import { default as indexC0QAO4uAwK446cvL35IeoUlvf80e_3lhq0EBhhdUzU8Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/task-templates/index.vue?macro=true";
import { default as _91UUID_93ZxePqOI83jV8Lo6ejWUjHErPnJVWqA1LHyjyrSf4rYAMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/task-templates/[UUID].vue?macro=true";
import { default as add_45task_45templateZmGE_8CHDZtqiMtL11QtUwq_qNVyeO_g4DRmk_tZhl0Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/task-templates/add-task-template.vue?macro=true";
import { default as task_45templates85lWPJW679fZuYwhUIXsuD_l4OHrVqZnt3Rt76aZ_KwMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/task-templates.vue?macro=true";
import { default as indexmAnaDWMJIv5QQeO_qif7Ff7cqxrpZBPI3KrdZw1rWo8Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/endpoint-servers/index.vue?macro=true";
import { default as _91UUID_93tT9Pzj329Ph4kmsl4T_0yS_3AbBh3wD74aVw25_h41sMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/endpoint-servers/[UUID].vue?macro=true";
import { default as add_45serverjLl7GcihmaRd3dBVuk7p8rPIXSwvDPH1rf_3i823HlIMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/endpoint-servers/add-server.vue?macro=true";
import { default as add_45file_45server8fwiHV0urvYldZyrGXAzwvBMOg9G7V_VonEIx5cUZ_UMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/endpoint-servers/add-file-server.vue?macro=true";
import { default as endpoint_45servers_tZRDGyGXP7TgNXNI6WghQZoMu70vDOJW2RC6IPcpr0Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/endpoint-servers.vue?macro=true";
import { default as index34bKkeUMEV70qctOViGdvesMOhvemmAlkuyKTHPZ6UEMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/system-variables/index.vue?macro=true";
import { default as system_45variables8ma8bxTRv684qnyBUuPOTmh_rGP7Ye5WR0Udvd3CWH4Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/system-variables.vue?macro=true";
import { default as indexWKctIPBaED4IfaIHEKWNO1QX4IY0XkNKVjksiJN_FggMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/force-logout/index.vue?macro=true";
import { default as indexpfVx_OmUwNN1NgUYskgOnwzoVj0cWiHpXzIk9ceE9nUMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/snapshots-progress/index.vue?macro=true";
import { default as snapshots_45progressrGOO6z6x3TvI4Qp7i2P1yBjr7YKV_WNH7jJ9sKkgbJQMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/snapshots-progress.vue?macro=true";
import { default as indexnBNF0N5_QZKJ2iot4dzJERfAYkw9hWY6eVFSfr1oo_kMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/email-configuration/index.vue?macro=true";
import { default as email_45configurationYmtHtMZZ9evZfOwRmV0_6DITEc2g8Qi5pCScaRgBhFwMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/email-configuration.vue?macro=true";
import { default as indext4vd3LgCb7NVJzRz0qiJJiZMKUaQ4hzAQi5Qu5fpxcQMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/user-authorizations/[tab]/index.vue?macro=true";
import { default as add_45uservVjNPqzPTjzluo_HlkCntLSOhxn74mnqlrzw4RLSRB0Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/user-authorizations/users/add-user.vue?macro=true";
import { default as import_45user_muhisemjCRxH__R5ncZ4SK7C_zbYAxCmaggiJrCZMIMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/user-authorizations/users/import-user.vue?macro=true";
import { default as _91id_93Y5kSWMarQI8nT6He0hGa8BVRnrB05BhUKK_88j05xrwMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/user-authorizations/users/manage/[id].vue?macro=true";
import { default as _91id_93QlZ_J2pC_XpokCGZOTNALIPTpaF8MRGbhpItLBKit6kMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/user-authorizations/users/change-logs/[id].vue?macro=true";
import { default as user_45authorizationsG4SQCoEXlrOlQ18pqs_ODo6BgXfB_wWbK_4kOWlmBHkMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/user-authorizations.vue?macro=true";
import { default as application_45insightsYb_OteOVt1ERcHx5jDKqDNW2Go3rS8t_tSUvWGbN7sMMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/application-insights.vue?macro=true";
import { default as indexWhoxysnQHNocw5Y5M9g2LzQ0o8mZht0_fKc9soRXVY0Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/application-packages/index.vue?macro=true";
import { default as manageKA_YFlZQOLGpXyjCDHIsyGq4mUmp2cgZXWkYP0v88DgMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/application-packages/[uuid]/manage.vue?macro=true";
import { default as indexEQI9WZ79l7mJsf84dQWAypZS9R6oMJ_wrptEr02WVOoMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/application-packages/[uuid]/[tab]/index.vue?macro=true";
import { default as _91action_93rWwY_y7CALcPp7QttR6TUXKQh9uKlBLglg1lMA29SIUMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/application-packages/[uuid]/[tab]/[action].vue?macro=true";
import { default as _91uuid_93148p6hztgUjgVUn55Z33RHJAwXLKlC5FeH0ddmwGWwcMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/application-packages/[uuid].vue?macro=true";
import { default as add_45application_45packagej7sE2lIBT7bP1hNzratha278ICkCqe45ie6nIv06yDgMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/application-packages/add-application-package.vue?macro=true";
import { default as application_45packagesHsnkPZz5UGKYGGSeZ90tA7UrHn7DiSaKTQn0wnbqUe0Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/application-packages.vue?macro=true";
import { default as scim_45ip_45whitelistingGI4JO3A4FgrDKv4FNdkBTX8aaWnuW5JqsMhQP9IKN_MMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/scim-ip-whitelisting.vue?macro=true";
import { default as indexsuwAG8P2uAr1U_9yWh49RQecV7hkx3IGoEZGM0quVKgMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/notification-template/index.vue?macro=true";
import { default as _91UUID_93YpXgkxC_utVnP8srljsHiEOTuFEfNv7y_WuSchkmXRIMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/notification-template/[UUID].vue?macro=true";
import { default as add_45templateHBYVN_3i_lTv1YRBfZrE6of8OEzv1RVWMbS7TP1H6RQMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/notification-template/add-template.vue?macro=true";
import { default as notification_45templateiYCas3LNOL_vjATiv8an1Y82WW3J_QNssVdUIVvN9BkMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/notification-template.vue?macro=true";
import { default as index80Mwp_UsIHKRnnKwaRzQHwkE_6Y5MFcniLUY6Lzk_UcMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/ai-foundry/models/index.vue?macro=true";
import { default as indexY7uS3Xsej9deUHvBgnJXajdrzJMXCgTZ4Y_a0iDkCiQMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/workflow-trigger-log/index.vue?macro=true";
import { default as indexYlj1fR_2YzK0hK615tiPbkz9T4pTDAMsVHDLlRYn1tgMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/container-applications/index.vue?macro=true";
import { default as data_45export_45endpoint_45serversg70oIqtRy3k8G8o2KzSGGwtgPMqEQCkQnWpEKit8ZaEMeta } from "/azp/agent/_work/5/s/frontend/pages/admin/data-export-endpoint-servers.vue?macro=true";
import { default as indexiEp33sDO8OhvP7h0X_hhORcPv_fheU1sQg4HAjFyav8Meta } from "/azp/agent/_work/5/s/frontend/pages/admin/ai-foundry/document-intelligence/index.vue?macro=true";
import { default as admin2q_AnLKjML_zD3PwG5F8jpsFpT2uyiB79TWeOkK9hB4Meta } from "/azp/agent/_work/5/s/frontend/pages/admin.vue?macro=true";
import { default as indexxcU3A9jV8RtlcWuPH2x89djhQ1jFHGlthcBBvrJyg1YMeta } from "/azp/agent/_work/5/s/frontend/pages/index.vue?macro=true";
import { default as mys6ZBy2zzjLqMzUEuIFGu26oExE_A4FFsMkxkeaAvF7cMeta } from "/azp/agent/_work/5/s/frontend/pages/tasks/my.vue?macro=true";
import { default as indexH3AoeGYeI_eHCf7poSip4ugXu39PIRvnRu8o9t_zgqMMeta } from "/azp/agent/_work/5/s/frontend/pages/tasks/history/index.vue?macro=true";
import { default as historycKxETWhdJzzh1imeS0kUZ50g6IhLIxddAU0CZ_lGj9oMeta } from "/azp/agent/_work/5/s/frontend/pages/tasks/history.vue?macro=true";
import { default as tasksYDEPg_iU8xBpM4P8jdkXimfBaUiPqaQDOK4JKC___f8Meta } from "/azp/agent/_work/5/s/frontend/pages/tasks.vue?macro=true";
import { default as logoutRcKGUe2oEfxeSuVyFZvAjf_HUbag5FX4W4rbHUSBerAMeta } from "/azp/agent/_work/5/s/frontend/pages/logout.vue?macro=true";
import { default as _91_46_46_46slug_93n_cEpWQfpYr4bpgbUAgAdKeHsCgSu2Vtx1_97ffYQQIMeta } from "/azp/agent/_work/5/s/frontend/pages/[...slug].vue?macro=true";
import { default as launchpadMDepmA3b6U8zokD_CK4sCpohu2TQ99PVlDUCR30IEiEMeta } from "/azp/agent/_work/5/s/frontend/pages/launchpad.vue?macro=true";
import { default as maintenancenM_d_JXcYrz1YFIZVtC_Y__zwsPptHRhSAqEly51v6MMeta } from "/azp/agent/_work/5/s/frontend/pages/maintenance.vue?macro=true";
import { default as _91_91mode_93_939vXn5BQefP2KcXVaW_NmQvj62WElxzf8Jqftxb6CRzAMeta } from "/azp/agent/_work/5/s/frontend/pages/wizard/[url]/[recordUUID]/[[phase]]/[[step]]/[[mode]].vue?macro=true";
import { default as _91recordUUID_93NR15fXjM4VjVFP2mfJumCqrIsydPmVkL_f0O9M9FCicMeta } from "/azp/agent/_work/5/s/frontend/pages/wizard/[url]/[recordUUID].vue?macro=true";
import { default as _91url_93KAfaijjJL5fNDT1BEW_fqTpwg4TOJEt8lGuAWVbVj8QMeta } from "/azp/agent/_work/5/s/frontend/pages/wizard/[url].vue?macro=true";
import { default as not_45authorized4HjXiq3NNhRocbUupzuAp4dKY6c6e82amZ9TbAF2MaEMeta } from "/azp/agent/_work/5/s/frontend/pages/not-authorized.vue?macro=true";
import { default as indexyNDNuWOLhXBczs_sKQNx7Q79Ugorr0QBvQy0yMDlL9kMeta } from "/azp/agent/_work/5/s/frontend/pages/form/[url]/index.vue?macro=true";
import { default as _91UUID_935xxhiihFcNw_myS1gkuOtw40HTQPS6_XYYvBIFKrimAMeta } from "/azp/agent/_work/5/s/frontend/pages/widgets/analyze/[UUID].vue?macro=true";
import { default as index9ddaL9pUhZZY1POMNjDkrp2Cd_vkPBjb4_R8Y1P2qw8Meta } from "/azp/agent/_work/5/s/frontend/pages/form/[url]/[tenantEntryUUID]/index.vue?macro=true";
import { default as _91recordUUID_93zXiH8_B_AfWNnokNzra3FfY4WH5W0U_Nl5M70cnSQAgMeta } from "/azp/agent/_work/5/s/frontend/pages/form/[url]/[tenantEntryUUID]/[recordUUID].vue?macro=true";
import { default as _91tenantEntryUUID_93BrGfUAe2WnGlAwRltTbChmbsP8MLADO9_FdM1KIHAg8Meta } from "/azp/agent/_work/5/s/frontend/pages/form/[url]/[tenantEntryUUID].vue?macro=true";
export default [
  {
    name: user2Nytptzob8KasznEl_3yq4tRyuqCqFKWNPqwf_oRGyAMeta?.name,
    path: "/user",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/user.vue"),
    children: [
  {
    name: "user",
    path: "",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/user/index.vue")
  },
  {
    name: "user-downloads",
    path: "downloads",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/user/downloads/index.vue")
  },
  {
    name: "user-delegate-account",
    path: "delegate-account",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/user/delegate-account.vue")
  },
  {
    name: "user-account-details",
    path: "account-details",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/user/account-details/index.vue")
  },
  {
    name: "user-change-password",
    path: "change-password",
    meta: indexx7Dc9uuS4_jObW29lrxEGaWGenPVzenrSaKoMdYlKUEMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/user/change-password/index.vue")
  },
  {
    name: "user-platform-notifications",
    path: "platform-notifications",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/user/platform-notifications/index.vue")
  }
]
  },
  {
    name: admin2q_AnLKjML_zD3PwG5F8jpsFpT2uyiB79TWeOkK9hB4Meta?.name,
    path: "/admin",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin.vue"),
    children: [
  {
    name: jobs2AmrIzbHe3CccsP_4J8CRBL7whM5GEQhTr0cuPD_4l4Meta?.name,
    path: "jobs",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/jobs.vue"),
    children: [
  {
    name: "admin-jobs-add",
    path: "add",
    meta: addvNXXIE9tRznQaRkoppkK98ylLAYVId4zf8GSpzEttpIMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/jobs/add.vue")
  },
  {
    name: "admin-jobs",
    path: "",
    meta: index9vGLtIZATMmq7sI0BQA1NFYbZLwu1uQ2B5buQkCyRYUMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/jobs/index.vue")
  },
  {
    name: "admin-jobs-UUID",
    path: ":UUID()",
    meta: _91UUID_93YNKImdX4CdZ1otEN1MLAbclH0uCdR2OytsdT5Aa7Es8Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/jobs/[UUID].vue")
  },
  {
    name: "admin-jobs-history-id",
    path: "history/:id?",
    meta: _91_91id_93_93dvqaRNY_UgGZJgmNCugI5zbe2tD1CVytcvszjlwUgDYMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/jobs/history/[[id]].vue")
  }
]
  },
  {
    name: "admin",
    path: "",
    meta: indexcKx4CMg8WrkHFGw3jKu0wlJS3exBNf7hTS9YFqSI0QAMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/index.vue")
  },
  {
    name: rolesWnrNzNfpYnes6Pzig18jobei_xElUAV0p3OenML7CX0Meta?.name,
    path: "roles",
    meta: rolesWnrNzNfpYnes6Pzig18jobei_xElUAV0p3OenML7CX0Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/roles.vue"),
    children: [
  {
    name: "admin-roles-add",
    path: "add",
    meta: addqSC6yKx30osAyxBpQ6wAKJ85BY1eRZ8QcnrSQRM_MVsMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/roles/add.vue")
  },
  {
    name: "admin-roles-ID",
    path: ":ID()",
    meta: _91ID_938zNkK8nWBlueyPQ4CQdUdoA7jwU6zHjwhVO5GnjExq0Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/roles/[ID].vue")
  },
  {
    name: "admin-roles",
    path: "",
    meta: index9D8JrX1hZQ3bMh2RymBJaeJ23Xe8KVzyxdVFmeZ_RH4Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/roles/index.vue")
  },
  {
    name: "admin-roles-authorizations-add",
    path: "authorizations/add",
    meta: addiN1GAVDpsry_wqx0Bk4jBwjAfq_U_M8nNYDGWMhRvvUMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/roles/authorizations/add.vue")
  },
  {
    name: "admin-roles-authorizations-ID",
    path: "authorizations/:ID()",
    meta: _91ID_93JXESyaVLqP5f4sN7pu05l2bWMoEazl4702DKiG9JwXMMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/roles/authorizations/[ID].vue")
  }
]
  },
  {
    name: "admin-entity",
    path: "entity",
    meta: entity6Swk4EBXLRdlo5OwXtlmMAYVLfqra_uqY3a_i9uIJGUMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/entity.vue"),
    children: [
  {
    name: "admin-entity-tab",
    path: ":tab()",
    meta: indexmv2EPZ_DIG20SW3c25i1XjRilT5PV1CgK8GnWJLGbiwMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/entity/[tab]/index.vue")
  }
]
  },
  {
    name: datasetPK5C3zZg4eY0i_XYMJgb0ZMfmWi9OoWhIFJCVSWeXcwMeta?.name,
    path: "dataset",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dataset.vue"),
    children: [
  {
    name: "admin-dataset-add",
    path: "add",
    meta: addvujJRL0nFiTbkMaNbICr4Y756r2Ns8MFpf5NxNUALY4Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dataset/add.vue")
  },
  {
    name: "admin-dataset",
    path: "",
    meta: indexAman397ehQ0ZlcSA1pVz86eNXXuKHcqD24vwBTRAYnQMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dataset/index.vue")
  },
  {
    name: "admin-dataset-edit-UUID",
    path: "edit/:UUID()",
    meta: _91UUID_93zWpQeoR2wFDn4XsNOFjC4E9ejMpmHwjSE7_oMiwsaTYMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dataset/edit/[UUID].vue")
  },
  {
    name: "admin-dataset-details-UUID-name",
    path: "details/:UUID()/:name()",
    meta: _91name_93lxaaw6IbOAB1TJpseOZIWL6Bw_OTLOhWRjhrM37__MoMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dataset/details/[UUID]/[name].vue")
  },
  {
    name: "admin-dataset-credentials-UUID-add",
    path: "credentials/:UUID()/add",
    meta: addEboC7PI18SlkNIg65wxm4Sm35BT40TTXpLgYAJUUPYkMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dataset/credentials/[UUID]/add.vue")
  },
  {
    name: "admin-dataset-credentials-UUID",
    path: "credentials/:UUID()",
    meta: index_yUpiv0gBNmgKwtxf_jrt10QxYO8VfukgX75L62jjFgMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dataset/credentials/[UUID]/index.vue")
  },
  {
    name: "admin-dataset-manage-UUID-name",
    path: "manage/:UUID?/:name?",
    meta: _91_91name_93_93IisvMysaNzQwbTVJjg_9oSmXQ9gxYISVCkp1Eyq3GIgMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dataset/manage/[[UUID]]/[[name]].vue")
  },
  {
    name: "admin-dataset-credentials-UUID-credentialUUID",
    path: "credentials/:UUID()/:credentialUUID()",
    meta: _91credentialUUID_93d26J_uahj8_u23OvB2wJWaya5_pqqHanauE5QMh0Dk4Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dataset/credentials/[UUID]/[credentialUUID].vue")
  }
]
  },
  {
    name: objectsFn3bcxWWAU6sGXacOYbxW8ZI9KvIvP2I9_Z8EufbyjEMeta?.name,
    path: "objects",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/objects.vue"),
    children: [
  {
    name: "admin-objects",
    path: "",
    meta: index1fbB9nvIZeilsk6uV0nu_sgKxC5YoBpsqXJTqq3DqGYMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/objects/index.vue")
  },
  {
    name: "admin-objects-overview-UUID",
    path: "overview/:UUID()",
    meta: _91UUID_93WSX0xY7oHx_Elstuyeu9cBRqPtiQZZGI7TRsk937OXQMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/objects/overview/[UUID].vue")
  },
  {
    name: "admin-objects-objectUUID-records",
    path: ":objectUUID()/records",
    meta: recordsIP6lT4KG6wYN14kf4SJT0dx8qg1YEk4I7eCxwRHGqfEMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/records.vue"),
    children: [
  {
    name: "admin-objects-objectUUID-records-add",
    path: "add",
    meta: addRIqYDPseGD3rMv7GIvTTm1RsoR2I99UFyTxy0hOaNwwMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/records/add.vue")
  },
  {
    name: "admin-objects-objectUUID-records-recordUUID",
    path: ":recordUUID?",
    meta: _91_91recordUUID_93_93tJlJH19SPPnHHAVwEqcS2CbJHDYmRsMFeSeTWH8Mb8UMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/records/[[recordUUID]].vue")
  }
]
  },
  {
    name: "admin-objects-objectUUID-templates",
    path: ":objectUUID()/templates",
    meta: templatesYM7Kmw7QHY3rJ3KorkTSHJ9ufA0Oc3nY55nOyhYnincMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/templates.vue"),
    children: [
  {
    name: "admin-objects-objectUUID-templates-templateUUID",
    path: ":templateUUID?",
    meta: _91_91templateUUID_93_93IRnPlvovuqlLUn9qvpZC4Av3mtfq4vMcKWpEy_GM9HgMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/templates/[[templateUUID]].vue")
  }
]
  },
  {
    name: "admin-objects-objectUUID-display",
    path: ":objectUUID()/display",
    meta: indexOUoO3YwgTQGeu4_L8qK7pVQcNm4y3Z5k2PZNSuBR_2oMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/display/index.vue")
  },
  {
    name: "admin-objects-objectUUID-display-recordUUID",
    path: ":objectUUID()/display/:recordUUID()",
    meta: _91recordUUID_93NVq3CiQkicBzwAAn6WqY6giGiPOjxVvYLcNnOPPJEroMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/display/[recordUUID].vue"),
    children: [
  {
    name: "admin-objects-objectUUID-display-recordUUID-tab",
    path: ":tab?",
    meta: _91_91tab_93_936ST98Z_HcGGXR_khGG8j8cFGrPPI6tMo_CuMUQfQSjcMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/display/[recordUUID]/[[tab]].vue")
  }
]
  },
  {
    name: "admin-objects-objectUUID-rest-api-keys-UUID",
    path: ":objectUUID()/rest-api-keys/:UUID?",
    meta: indexP_tLicQLB1ereKukznm26IfePVZ_CvZt_NVFy_K2WPYMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/rest-api-keys/[[UUID]]/index.vue")
  },
  {
    name: "admin-objects-objectUUID-rest-api-keys-UUID-rules",
    path: ":objectUUID()/rest-api-keys/:UUID?/rules",
    meta: rulesP2PO_I57GKNeWCeMlCEHGf1PBNE2JtmDphYcGe8bfesMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/objects/[objectUUID]/rest-api-keys/[[UUID]]/rules.vue")
  }
]
  },
  {
    name: wizards_VEZLNBUB8BJkdjLRsRb6u_iXz16jhv_d3WZDGCbpZIMeta?.name,
    path: "wizards",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/wizards.vue"),
    children: [
  {
    name: "admin-wizards",
    path: "",
    meta: indexTugHtjWW3xpflQnOn5N2O_1sGlg_f9VAaFqski2_s3sMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/wizards/index.vue")
  },
  {
    name: "admin-wizards-UUID",
    path: ":UUID()",
    meta: _91UUID_93vl1VekD6EwEaj342bFmPEquMOBm7LUOFDIUvkzH6j2gMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/wizards/[UUID].vue")
  },
  {
    name: "admin-wizards-add-wizard",
    path: "add-wizard",
    meta: add_45wizard_XNJqVfTnTB8cS4Ocoj97yt7OQzZPa3DSlzo3uF0jOgMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/wizards/add-wizard.vue")
  },
  {
    name: "admin-wizards-manage-UUID",
    path: "manage/:UUID()",
    meta: _91UUID_93c0mcjE0rH9UBWvgtUu6KFCR_QshDpx2yQaAoM5Jza8EMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/wizards/manage/[UUID].vue")
  }
]
  },
  {
    name: cron_45jobsDG7bAZ8VTwlb2M8Hwbg0QwzM_qCnIz1c_0mKd0FZkCwMeta?.name,
    path: "cron-jobs",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/cron-jobs.vue"),
    children: [
  {
    name: "admin-cron-jobs",
    path: "",
    meta: indexA2HWu4wRpWCcM4KSJjbKyaCeTZsWSSR9mw4YVJ_TF1UMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/cron-jobs/index.vue")
  },
  {
    name: "admin-cron-jobs-name",
    path: ":name()",
    meta: _91name_934J7TxSYKvz_acD29Zoo7J_eX2SX6dwC1UaoThVuRC1MMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/cron-jobs/[name].vue")
  }
]
  },
  {
    name: languageszFudX7xjkcI3mXIXQFCS5jZzUVu6yIEhkay0PBz9adIMeta?.name,
    path: "languages",
    meta: languageszFudX7xjkcI3mXIXQFCS5jZzUVu6yIEhkay0PBz9adIMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/languages.vue"),
    children: [
  {
    name: "admin-languages-add",
    path: "add",
    meta: addPhk_vgs0eczAastmm_38wCfSJdDvpUxQ1k6JFMmQZvMMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/languages/add.vue")
  },
  {
    name: "admin-languages",
    path: "",
    meta: indexLkpDYBGORaAiRdOKtEhAXO0dOldKZrQqv6FnNXwmm3EMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/languages/index.vue")
  },
  {
    name: label_45groupssNrVO3ocLl5l0KknxiN8L_Bmn06aec2wbNwAfVPQoIAMeta?.name,
    path: "label-groups",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/languages/label-groups.vue"),
    children: [
  {
    name: "admin-languages-label-groups-add",
    path: "add",
    meta: addisJlyRLD5prmgu_lK6hqAbtlglISRivlJ9luPtGVW6oMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/languages/label-groups/add.vue")
  },
  {
    name: "admin-languages-label-groups",
    path: "",
    meta: index85OVl6qADQur4VZo7jAy1_tQwUVsKsfnkTLtqacw2_YMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/languages/label-groups/index.vue")
  },
  {
    name: "admin-languages-label-groups-labelGroupUUID",
    path: ":labelGroupUUID()",
    meta: _91labelGroupUUID_93F4PkBOH4_sc6U_ZSrJ2p2YlN7gp3wILgmOgofq3uWQYMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/languages/label-groups/[labelGroupUUID].vue")
  }
]
  },
  {
    name: labels9thjMYuwYHmL2LBroacG6sf8eioCuYeXcAHfrs0CxdMMeta?.name,
    path: ":languageUUID()/labels",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/languages/[languageUUID]/labels.vue"),
    children: [
  {
    name: "admin-languages-languageUUID-labels",
    path: "",
    meta: indexMYMkJHs6T_GRk0U8wQX_SYrHX0ez7wxJJGV8r3RBJZcMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/languages/[languageUUID]/labels/index.vue")
  },
  {
    name: "admin-languages-languageUUID-labels-labelUUID",
    path: ":labelUUID()",
    meta: _91labelUUID_93ClYUM5IEk0gzNXuD9Atci1mRjY4aQ4xv6Ka33g7h5EIMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/languages/[languageUUID]/labels/[labelUUID].vue")
  },
  {
    name: "admin-languages-languageUUID-labels-create-label",
    path: "create-label",
    meta: create_45labelirfdUiLvG5dEl9KVplHmCXa1gs8EHCOxlTpIn_uI75oMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/languages/[languageUUID]/labels/create-label.vue")
  }
]
  },
  {
    name: "admin-languages-languageUUID-edit-language",
    path: ":languageUUID()/edit-language",
    meta: edit_45languageuxESvwvhIZTkT_xFVgSDGyd_mpqbLko4WfBNWF7sH1YMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/languages/[languageUUID]/edit-language.vue")
  }
]
  },
  {
    name: dashboardsxLoXfrCyRXSFKe1Fis1WU5_2fCcM8TYsp761w57SKb0Meta?.name,
    path: "dashboards",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dashboards.vue"),
    children: [
  {
    name: "admin-dashboards-add",
    path: "add",
    meta: add4c2mBITcQNX6XfdJiFRKkHa1NyceAU5q04PX29srUj8Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dashboards/add.vue")
  },
  {
    name: "admin-dashboards",
    path: "",
    meta: indexbEFyJQ7tUnZnonnmjjaBYNkvM4k1gHz65E7MVHeA_noMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dashboards/index.vue")
  },
  {
    name: "admin-dashboards-UUID",
    path: ":UUID()",
    meta: _91UUID_93dlXwHwUjULRwg4mlfQtw13mt3Nl9JxArQokCR7FH_C0Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dashboards/[UUID].vue")
  },
  {
    name: designfBUB7IoJewGRJpjejMU7hqMHAJaLrdzlHsyE1vDUyDAMeta?.name,
    path: "design",
    meta: designfBUB7IoJewGRJpjejMU7hqMHAJaLrdzlHsyE1vDUyDAMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dashboards/design.vue"),
    children: [
  {
    name: "admin-dashboards-design",
    path: "",
    meta: indexpyK__jwvqPvF78kDCAQtDmof71GmJ79lZyiJhvKrnd4Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dashboards/design/index.vue")
  },
  {
    name: _91UUID_93_TuYyg0y6siF9Qh8XWbgOkwtKY3Oqzs5eGxjPCGKm1EMeta?.name,
    path: ":UUID()",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dashboards/design/[UUID].vue"),
    children: [
  {
    name: "admin-dashboards-design-UUID",
    path: "",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dashboards/design/[UUID]/index.vue")
  },
  {
    name: "admin-dashboards-design-UUID-mock-data",
    path: "mock-data",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dashboards/design/[UUID]/mock-data.js")
  },
  {
    name: "admin-dashboards-design-UUID-widgetUUID",
    path: ":widgetUUID()",
    meta: _91widgetUUID_93pV_gD2C4xfABQhmwjhLsLqEqvEQ5RdxaGyM7UvXcSz0Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/dashboards/design/[UUID]/[widgetUUID].vue")
  }
]
  }
]
  }
]
  },
  {
    name: "admin-sql-editor",
    path: "sql-editor",
    meta: sql_45editorGv252Yd1oTLaRzo_k9NZYC1EQqyFMHwYbxLDZB_grQEMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/sql-editor.vue")
  },
  {
    name: user_45feedsPgNiHz8XNomw1JT4howk76_QRgGxCBNF6LdHu73li2MMeta?.name,
    path: "user-feeds",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/user-feeds.vue"),
    children: [
  {
    name: "admin-user-feeds",
    path: "",
    meta: index_HXzbRG6VErQ_9A9UjdTYaSn5Ba_tsRJH0sMEtaXycsMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/user-feeds/index.vue")
  },
  {
    name: "admin-user-feeds-UUID",
    path: ":UUID()",
    meta: _91UUID_93KhaLvwxt7SAVI2rPOxpsmc7OQKatpxWbXAGjNEFeRVMMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/user-feeds/[UUID].vue")
  },
  {
    name: "admin-user-feeds-add-feed",
    path: "add-feed",
    meta: add_45feedi4Kp_rd29ThA0YCFQoylMHvdN5_OBn1uLvTaftKrLrMMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/user-feeds/add-feed.vue")
  }
]
  },
  {
    name: work_45flowsYyTrtRl_b43JsTO6ygzUCRdM5YiOJ7QrBXWwsWxyCfUMeta?.name,
    path: "work-flows",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/work-flows.vue"),
    children: [
  {
    name: "admin-work-flows",
    path: "",
    meta: indexoULsjGS7JrhWzeX0s5wQkQkKpIhBkK2dH8AQ6PXfU28Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/work-flows/index.vue")
  },
  {
    name: "admin-work-flows-design-id",
    path: "design/:id()",
    meta: _91id_93pf3BFPZ_ito9xd4IHlYW5ji3eYyTTs7lZcdgjuyFjQsMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/work-flows/design/[id].vue")
  },
  {
    name: "admin-work-flows-manage-id",
    path: "manage/:id?",
    meta: _91_91id_93_93P7nkJSeEPz9QmbtH5njigWFJZJCkbvQjlJbfp_1fiHQMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/work-flows/manage/[[id]].vue")
  }
]
  },
  {
    name: "admin-audit-trail",
    path: "audit-trail",
    meta: audit_45trailGevxDmgx1XwlcQ8w_7CD3j51m_fYiya9kd9sq84nBKQMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/audit-trail.vue")
  },
  {
    name: data_45exportd4RW04ms06dUsoaNd0UP5gvwuu_A64h1bjYWT6mishAMeta?.name,
    path: "data-export",
    meta: data_45exportd4RW04ms06dUsoaNd0UP5gvwuu_A64h1bjYWT6mishAMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/data-export.vue"),
    children: [
  {
    name: "admin-data-export",
    path: "",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/data-export/index.vue")
  }
]
  },
  {
    name: data_45modelsNSxGK5ot0PY4pnegtIzAEU46bZ8uKmVXmzTxrEYVR_sMeta?.name,
    path: "data-models",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/data-models.vue"),
    children: [
  {
    name: "admin-data-models",
    path: "",
    meta: indexnyrpwPKH2KNZj1YxUxagJZaYG5_IKnT_9J0PNdDSaUwMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/data-models/index.vue")
  },
  {
    name: "admin-data-models-UUID",
    path: ":UUID()",
    meta: _91UUID_93UmaqTS6busKkhWhRbRdDvLtwEkMgIGfFkspcgVwIpfEMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/data-models/[UUID].vue")
  },
  {
    name: "admin-data-models-add-data-model",
    path: "add-data-model",
    meta: add_45data_45modelI8pc4YnOhHkVgIeRHPATYAjOXtH2jj8_fLw8_KbmHBAMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/data-models/add-data-model.vue")
  },
  {
    name: "admin-data-models-import-data-model",
    path: "import-data-model",
    meta: import_45data_45model0CFYYjXXwlwd__Ym_87_RgljngRbURYtjufJVhnTh_QMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/data-models/import-data-model.vue")
  },
  {
    name: "admin-data-models-change-log-objectUUID",
    path: "change-log/:objectUUID()",
    meta: _91objectUUID_93nnJm81c4Bbi1eltBHkUILL3gSKdwi78S2QmJ_5tg_HwMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/data-models/change-log/[objectUUID].vue")
  }
]
  },
  {
    name: "admin-debug-trace",
    path: "debug-trace",
    meta: debug_45tracefMlSw0UHlAWLMpBIWFta8diWTUu8f7aDPSe8tDrMf38Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/debug-trace.vue")
  },
  {
    name: maintenancebYg3yb2aw6m2zugO_UYsL04yOdFm4WJEFtO4kMWlGEYMeta?.name,
    path: "maintenance",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/maintenance.vue"),
    children: [
  {
    name: "admin-maintenance",
    path: "",
    meta: indexs5xxRCE00jYMFdyXlyTNTUYmNI4lhI1x4wlq3cT_GDkMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/maintenance/index.vue")
  },
  {
    name: "admin-maintenance-UUID",
    path: ":UUID()",
    meta: _91UUID_93_wlGKsIITQxpMhdCno2Sol00YniPj_TWYH6DnBt9WZAMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/maintenance/[UUID].vue")
  },
  {
    name: "admin-maintenance-add-screen",
    path: "add-screen",
    meta: add_45screenuu1jKHpPzXvGISP00ZaB814zQB_1_651i6WZQWb3fE0Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/maintenance/add-screen.vue")
  }
]
  },
  {
    name: action_45flows64ryCJPiq2zjDKmOGQZL64YDUjL7rjwSmYjLNC7k4DMMeta?.name,
    path: "action-flows",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/action-flows.vue"),
    children: [
  {
    name: "admin-action-flows",
    path: "",
    meta: indexYpSNZQXVv5ScoT3INL2EU_pH3QgU1fffpfDCSyJopj0Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/action-flows/index.vue")
  },
  {
    name: "admin-action-flows-manage-add",
    path: "manage/add",
    meta: addgcA_nCOTumD9JF0EYDBT6rbemsIlSXjA7d5_u5OG0iUMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/action-flows/manage/add.vue")
  },
  {
    name: "admin-action-flows-design-id",
    path: "design/:id()",
    meta: _91id_931rSFjAkZ24S9ZbtZFSDDUW2WvFENbPvqFRUXim22zhQMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/action-flows/design/[id].vue")
  },
  {
    name: "admin-action-flows-manage-id",
    path: "manage/:id()",
    meta: _91id_931JGK86V1BaWzWlZNf_oNWFochr6uPG0qg6jg1LqLJqEMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/action-flows/manage/[id].vue")
  },
  {
    name: "admin-action-flows-history-id",
    path: "history/:id()",
    meta: index6GevRlURaVZGjVFhnm6Zt4RCnyc7NyRQIR78dyVFUzMMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/action-flows/history/[id]/index.vue")
  },
  {
    name: "admin-action-flows-history-id-historyUUID",
    path: "history/:id()/:historyUUID()",
    meta: _91historyUUID_93RNirVPwuSJV0UmcoOlaXHN0IR1I_hM5a6aZtPzhVXdUMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/action-flows/history/[id]/[historyUUID].vue")
  }
]
  },
  {
    name: "admin-applications",
    path: "applications",
    meta: applicationskh22bunxzIE0Y2gTOnRUJHstAs3Ol0KlP1IDvsWlklAMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/applications.vue"),
    children: [
  {
    name: "admin-applications-apps-add",
    path: "apps/add",
    meta: addyK2ZEJnng5tNfx6_iW87fUyFg5ABzSDwer7KlL1DR7MMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/applications/apps/add.vue")
  },
  {
    name: "admin-applications-tab",
    path: ":tab()",
    meta: index34E95HFDGIqf7EmzNPYUcEh_H6g0Fr_tbDVaiD1G0lwMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/applications/[tab]/index.vue")
  },
  {
    name: "admin-applications-categories-add",
    path: "categories/add",
    meta: addw9jiDVPQspc0H0M6K3LKSiapwJFqADR1QqjBy80DnXUMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/applications/categories/add.vue")
  },
  {
    name: "admin-applications-apps-manage-UUID",
    path: "apps/manage/:UUID()",
    meta: _91UUID_934ti1n1XX4IdNo5yEJoBGYoncNhkizewTtp_gdvfxSj4Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/applications/apps/manage/[UUID].vue")
  },
  {
    name: "admin-applications-menus-manage-UUID",
    path: "menus/manage/:UUID?",
    meta: _91_91UUID_93_93jKuwNtiD5j0Dmj7HQprCDzLQlFhbvVBu_51tjJIjfOQMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/applications/menus/manage/[[UUID]].vue")
  },
  {
    name: "admin-applications-solution-categories-add",
    path: "solution-categories/add",
    meta: addLdqkJWVf8fNOF7sSdtTrbWvY0WrSsfpb3cxbkdcF90UMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/applications/solution-categories/add.vue")
  },
  {
    name: "admin-applications-categories-manage-ID",
    path: "categories/manage/:ID?",
    meta: _91_91ID_93_93mu0dXN1n61XVnQm897LExvLN0X91xmyyLMJ5sjFN8fMMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/applications/categories/manage/[[ID]].vue")
  },
  {
    name: "admin-applications-solution-categories-manage-UUID",
    path: "solution-categories/manage/:UUID?",
    meta: _91_91UUID_93_93_Ez6txXFmKzmta4Wx8wAWb_69LZ_TSC_cRLu7ZGtLQsMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/applications/solution-categories/manage/[[UUID]].vue")
  }
]
  },
  {
    name: businessrulesqRR6wdEsuWJCMHSuIP8QKEPslPRCtS2DDanc_hO8va4Meta?.name,
    path: "businessrules",
    meta: businessrulesqRR6wdEsuWJCMHSuIP8QKEPslPRCtS2DDanc_hO8va4Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules.vue"),
    children: [
  {
    name: "admin-businessrules-add",
    path: "add",
    meta: addtsKeG5nfJTeRb2UmeKeElBcX_psAVp6yW7Cjf7qgRo4Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/add.vue")
  },
  {
    name: "admin-businessrules",
    path: "",
    meta: index6_nf_B4vGaJlF8PogCJZOM4Il5apdh3Ip6NWkPg6NgIMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/index.vue")
  },
  {
    name: "admin-businessrules-UUID",
    path: ":UUID()",
    meta: _91UUID_93C7YHZhnuGL6yZ_ZRfLwwWqkgicEXAUWQ7Eo7Q7C3itYMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID].vue"),
    children: [
  {
    name: "admin-businessrules-UUID-edit",
    path: "edit",
    meta: editPEheHjtNAb3CCY6Ry42kCzpyie1zYCdgEisHMKH_v5gMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit.vue"),
    children: [
  {
    name: "admin-businessrules-UUID-edit-kpis",
    path: "kpis",
    meta: kpisqvZidRJlbbZgufEMmELrurcI9qGz5JBZ4qxsOjnF80YMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit/kpis.vue")
  },
  {
    name: "admin-businessrules-UUID-edit-settings",
    path: "settings",
    meta: settingsJtrgUnf2myWT_qaAfDBPTpV87y3yX6LEufJ6dbP4jw4Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit/settings.vue")
  },
  {
    name: "admin-businessrules-UUID-edit-developer",
    path: "developer",
    meta: developerajiQjqr0aXL4xx7GeikQnKrsfzF0uEyNcnRESxFeoNQMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit/developer.vue")
  },
  {
    name: "admin-businessrules-UUID-edit-rest-apis",
    path: "rest-apis",
    meta: indexiW6G2zsA794AdqQ3qiXdJle8ZM8GjerXChiZvcbv7rwMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit/rest-apis/index.vue")
  },
  {
    name: "admin-businessrules-UUID-edit-customize-fields",
    path: "customize-fields",
    meta: customize_45fieldsPQZAJkiBjkhIUvWPmpokRZR2xsvquTCthjBPPMykmDcMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit/customize-fields.vue")
  },
  {
    name: "admin-businessrules-UUID-edit-rest-apis-restUUID",
    path: "rest-apis/:restUUID()",
    meta: indexqsrRlM3XZW0cduF25uta08lUs9Zt8xApRZLPEQ8G3nUMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit/rest-apis/[restUUID]/index.vue")
  },
  {
    name: "admin-businessrules-UUID-edit-rest-apis-restUUID-rules",
    path: "rest-apis/:restUUID()/rules",
    meta: rulesesZBQ__7_j7N4B_MA_X_tO8Pg68__mXDmID_JAnQuZwMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/edit/rest-apis/[restUUID]/rules.vue")
  }
]
  },
  {
    name: "admin-businessrules-UUID-overview",
    path: "overview",
    meta: overviewYY77zh0G3_TIl6_CJt_DIVLdQq9sVLnGx2TbTBfS9RgMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/overview.vue"),
    children: [
  {
    name: "admin-businessrules-UUID-overview-state",
    path: ":state?",
    meta: _91_91state_93_93KdKl3zTpO2gxY9bQcd3Naj1hJ8a_jH8aToH2D3r2gDQMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/overview/[[state]].vue")
  }
]
  },
  {
    name: "admin-businessrules-UUID-changelog",
    path: "changelog",
    meta: changelog4dE7Exywwz8qBCHIMg1alwvPt4r5qzBC3qAirs_16RAMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/changelog.vue")
  },
  {
    name: "admin-businessrules-UUID-whitelisting",
    path: "whitelisting",
    meta: whitelistingkRlWl4xk8RXEom5CiffKOiAiAcCS7f_5eG_dYIDPP0sMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/whitelisting.vue")
  },
  {
    name: "admin-businessrules-UUID-notifications",
    path: "notifications",
    meta: notificationsK5HgC_zSayUQpJZadIfxqq0ZFJ_OCDgXVOp0vkBTCsYMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/businessrules/[UUID]/notifications.vue")
  }
]
  }
]
  },
  {
    name: external_45apisVSKp2vduHbAbQyk27LJTKumiLBp6s_EB0kie0vsWrbUMeta?.name,
    path: "external-apis",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/external-apis.vue"),
    children: [
  {
    name: "admin-external-apis",
    path: "",
    meta: indextobQ_GVjydNdjOqmHBWwFIFqHi0KW81D25LgwAKSglQMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/external-apis/index.vue")
  }
]
  },
  {
    name: "admin-notifications",
    path: "notifications",
    meta: notificationsy1ls3Vw31MKOKrXFksOWCJoYeCdmRALoeukGv3xUN64Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/notifications.vue"),
    children: [
  {
    name: "admin-notifications-UUID-notificationUUID",
    path: ":UUID?/:notificationUUID?",
    meta: _91_91notificationUUID_93_93GRYtJZPMixj5PcY02q9ltnls5mQU4AOEQgrhCnfAgU4Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/notifications/[[UUID]]/[[notificationUUID]].vue")
  }
]
  },
  {
    name: package_45marketqS3CBBPmxBJcdOowVlD3wjrlJih9uKjI1rqeOAd6jGAMeta?.name,
    path: "package-market",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/package-market.vue"),
    children: [
  {
    name: "admin-package-market",
    path: "",
    meta: indexnbtpESt2FvYkthylaOuNCW5F_85x7izymW7YN3KYt7kMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/package-market/index.vue")
  },
  {
    name: "admin-package-market-packageUUID",
    path: ":packageUUID()",
    meta: indexZdnETJ5vmhuc0QBImoEOeavUV8jas0KPdhhISG6iW_kMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/package-market/[packageUUID]/index.vue")
  },
  {
    name: "admin-package-market-packageUUID-details",
    path: ":packageUUID()/details",
    meta: indexzfdbuKXfR_0L_OyeF0JtuAs7mPnq6IKScUucALMn9tcMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/package-market/[packageUUID]/details/index.vue")
  },
  {
    name: "admin-package-market-packageUUID-details-releaseUUID",
    path: ":packageUUID()/details/:releaseUUID()",
    meta: _91releaseUUID_93cG_0Hl_A3WjyR5cg33q3iBuPc_ZRY2KpMT9bRpYzGDoMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/package-market/[packageUUID]/details/[releaseUUID].vue")
  }
]
  },
  {
    name: task_45templates85lWPJW679fZuYwhUIXsuD_l4OHrVqZnt3Rt76aZ_KwMeta?.name,
    path: "task-templates",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/task-templates.vue"),
    children: [
  {
    name: "admin-task-templates",
    path: "",
    meta: indexC0QAO4uAwK446cvL35IeoUlvf80e_3lhq0EBhhdUzU8Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/task-templates/index.vue")
  },
  {
    name: "admin-task-templates-UUID",
    path: ":UUID()",
    meta: _91UUID_93ZxePqOI83jV8Lo6ejWUjHErPnJVWqA1LHyjyrSf4rYAMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/task-templates/[UUID].vue")
  },
  {
    name: "admin-task-templates-add-task-template",
    path: "add-task-template",
    meta: add_45task_45templateZmGE_8CHDZtqiMtL11QtUwq_qNVyeO_g4DRmk_tZhl0Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/task-templates/add-task-template.vue")
  }
]
  },
  {
    name: endpoint_45servers_tZRDGyGXP7TgNXNI6WghQZoMu70vDOJW2RC6IPcpr0Meta?.name,
    path: "endpoint-servers",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/endpoint-servers.vue"),
    children: [
  {
    name: "admin-endpoint-servers",
    path: "",
    meta: indexmAnaDWMJIv5QQeO_qif7Ff7cqxrpZBPI3KrdZw1rWo8Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/endpoint-servers/index.vue")
  },
  {
    name: "admin-endpoint-servers-UUID",
    path: ":UUID()",
    meta: _91UUID_93tT9Pzj329Ph4kmsl4T_0yS_3AbBh3wD74aVw25_h41sMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/endpoint-servers/[UUID].vue")
  },
  {
    name: "admin-endpoint-servers-add-server",
    path: "add-server",
    meta: add_45serverjLl7GcihmaRd3dBVuk7p8rPIXSwvDPH1rf_3i823HlIMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/endpoint-servers/add-server.vue")
  },
  {
    name: "admin-endpoint-servers-add-file-server",
    path: "add-file-server",
    meta: add_45file_45server8fwiHV0urvYldZyrGXAzwvBMOg9G7V_VonEIx5cUZ_UMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/endpoint-servers/add-file-server.vue")
  }
]
  },
  {
    name: system_45variables8ma8bxTRv684qnyBUuPOTmh_rGP7Ye5WR0Udvd3CWH4Meta?.name,
    path: "system-variables",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/system-variables.vue"),
    children: [
  {
    name: "admin-system-variables",
    path: "",
    meta: index34bKkeUMEV70qctOViGdvesMOhvemmAlkuyKTHPZ6UEMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/system-variables/index.vue")
  }
]
  },
  {
    name: "admin-force-logout",
    path: "force-logout",
    meta: indexWKctIPBaED4IfaIHEKWNO1QX4IY0XkNKVjksiJN_FggMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/force-logout/index.vue")
  },
  {
    name: snapshots_45progressrGOO6z6x3TvI4Qp7i2P1yBjr7YKV_WNH7jJ9sKkgbJQMeta?.name,
    path: "snapshots-progress",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/snapshots-progress.vue"),
    children: [
  {
    name: "admin-snapshots-progress",
    path: "",
    meta: indexpfVx_OmUwNN1NgUYskgOnwzoVj0cWiHpXzIk9ceE9nUMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/snapshots-progress/index.vue")
  }
]
  },
  {
    name: email_45configurationYmtHtMZZ9evZfOwRmV0_6DITEc2g8Qi5pCScaRgBhFwMeta?.name,
    path: "email-configuration",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/email-configuration.vue"),
    children: [
  {
    name: "admin-email-configuration",
    path: "",
    meta: indexnBNF0N5_QZKJ2iot4dzJERfAYkw9hWY6eVFSfr1oo_kMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/email-configuration/index.vue")
  }
]
  },
  {
    name: "admin-user-authorizations",
    path: "user-authorizations",
    meta: user_45authorizationsG4SQCoEXlrOlQ18pqs_ODo6BgXfB_wWbK_4kOWlmBHkMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/user-authorizations.vue"),
    children: [
  {
    name: "admin-user-authorizations-tab",
    path: ":tab()",
    meta: indext4vd3LgCb7NVJzRz0qiJJiZMKUaQ4hzAQi5Qu5fpxcQMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/user-authorizations/[tab]/index.vue")
  },
  {
    name: "admin-user-authorizations-users-add-user",
    path: "users/add-user",
    meta: add_45uservVjNPqzPTjzluo_HlkCntLSOhxn74mnqlrzw4RLSRB0Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/user-authorizations/users/add-user.vue")
  },
  {
    name: "admin-user-authorizations-users-import-user",
    path: "users/import-user",
    meta: import_45user_muhisemjCRxH__R5ncZ4SK7C_zbYAxCmaggiJrCZMIMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/user-authorizations/users/import-user.vue")
  },
  {
    name: "admin-user-authorizations-users-manage-id",
    path: "users/manage/:id()",
    meta: _91id_93Y5kSWMarQI8nT6He0hGa8BVRnrB05BhUKK_88j05xrwMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/user-authorizations/users/manage/[id].vue")
  },
  {
    name: "admin-user-authorizations-users-change-logs-id",
    path: "users/change-logs/:id()",
    meta: _91id_93QlZ_J2pC_XpokCGZOTNALIPTpaF8MRGbhpItLBKit6kMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/user-authorizations/users/change-logs/[id].vue")
  }
]
  },
  {
    name: "admin-application-insights",
    path: "application-insights",
    meta: application_45insightsYb_OteOVt1ERcHx5jDKqDNW2Go3rS8t_tSUvWGbN7sMMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/application-insights.vue")
  },
  {
    name: application_45packagesHsnkPZz5UGKYGGSeZ90tA7UrHn7DiSaKTQn0wnbqUe0Meta?.name,
    path: "application-packages",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/application-packages.vue"),
    children: [
  {
    name: "admin-application-packages",
    path: "",
    meta: indexWhoxysnQHNocw5Y5M9g2LzQ0o8mZht0_fKc9soRXVY0Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/application-packages/index.vue")
  },
  {
    name: "admin-application-packages-uuid",
    path: ":uuid()",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/application-packages/[uuid].vue"),
    children: [
  {
    name: "admin-application-packages-uuid-manage",
    path: "manage",
    meta: manageKA_YFlZQOLGpXyjCDHIsyGq4mUmp2cgZXWkYP0v88DgMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/application-packages/[uuid]/manage.vue")
  },
  {
    name: "admin-application-packages-uuid-tab",
    path: ":tab()",
    meta: indexEQI9WZ79l7mJsf84dQWAypZS9R6oMJ_wrptEr02WVOoMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/application-packages/[uuid]/[tab]/index.vue")
  },
  {
    name: "admin-application-packages-uuid-tab-action",
    path: ":tab()/:action()",
    meta: _91action_93rWwY_y7CALcPp7QttR6TUXKQh9uKlBLglg1lMA29SIUMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/application-packages/[uuid]/[tab]/[action].vue")
  }
]
  },
  {
    name: "admin-application-packages-add-application-package",
    path: "add-application-package",
    meta: add_45application_45packagej7sE2lIBT7bP1hNzratha278ICkCqe45ie6nIv06yDgMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/application-packages/add-application-package.vue")
  }
]
  },
  {
    name: "admin-scim-ip-whitelisting",
    path: "scim-ip-whitelisting",
    meta: scim_45ip_45whitelistingGI4JO3A4FgrDKv4FNdkBTX8aaWnuW5JqsMhQP9IKN_MMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/scim-ip-whitelisting.vue")
  },
  {
    name: notification_45templateiYCas3LNOL_vjATiv8an1Y82WW3J_QNssVdUIVvN9BkMeta?.name,
    path: "notification-template",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/notification-template.vue"),
    children: [
  {
    name: "admin-notification-template",
    path: "",
    meta: indexsuwAG8P2uAr1U_9yWh49RQecV7hkx3IGoEZGM0quVKgMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/notification-template/index.vue")
  },
  {
    name: "admin-notification-template-UUID",
    path: ":UUID()",
    meta: _91UUID_93YpXgkxC_utVnP8srljsHiEOTuFEfNv7y_WuSchkmXRIMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/notification-template/[UUID].vue")
  },
  {
    name: "admin-notification-template-add-template",
    path: "add-template",
    meta: add_45templateHBYVN_3i_lTv1YRBfZrE6of8OEzv1RVWMbS7TP1H6RQMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/notification-template/add-template.vue")
  }
]
  },
  {
    name: "admin-ai-foundry-models",
    path: "ai-foundry/models",
    meta: index80Mwp_UsIHKRnnKwaRzQHwkE_6Y5MFcniLUY6Lzk_UcMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/ai-foundry/models/index.vue")
  },
  {
    name: "admin-workflow-trigger-log",
    path: "workflow-trigger-log",
    meta: indexY7uS3Xsej9deUHvBgnJXajdrzJMXCgTZ4Y_a0iDkCiQMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/workflow-trigger-log/index.vue")
  },
  {
    name: "admin-container-applications",
    path: "container-applications",
    meta: indexYlj1fR_2YzK0hK615tiPbkz9T4pTDAMsVHDLlRYn1tgMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/container-applications/index.vue")
  },
  {
    name: "admin-data-export-endpoint-servers",
    path: "data-export-endpoint-servers",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/data-export-endpoint-servers.vue")
  },
  {
    name: "admin-ai-foundry-document-intelligence",
    path: "ai-foundry/document-intelligence",
    meta: indexiEp33sDO8OhvP7h0X_hhORcPv_fheU1sQg4HAjFyav8Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/admin/ai-foundry/document-intelligence/index.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/index.vue")
  },
  {
    name: "tasks",
    path: "/tasks",
    meta: tasksYDEPg_iU8xBpM4P8jdkXimfBaUiPqaQDOK4JKC___f8Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/tasks.vue"),
    children: [
  {
    name: "tasks-my",
    path: "my",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/tasks/my.vue")
  },
  {
    name: historycKxETWhdJzzh1imeS0kUZ50g6IhLIxddAU0CZ_lGj9oMeta?.name,
    path: "history",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/tasks/history.vue"),
    children: [
  {
    name: "tasks-history",
    path: "",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/tasks/history/index.vue")
  }
]
  }
]
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutRcKGUe2oEfxeSuVyFZvAjf_HUbag5FX4W4rbHUSBerAMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/logout.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/[...slug].vue")
  },
  {
    name: "launchpad",
    path: "/launchpad",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/launchpad.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenancenM_d_JXcYrz1YFIZVtC_Y__zwsPptHRhSAqEly51v6MMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/maintenance.vue")
  },
  {
    name: "wizard-url",
    path: "/wizard/:url()",
    meta: _91url_93KAfaijjJL5fNDT1BEW_fqTpwg4TOJEt8lGuAWVbVj8QMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/wizard/[url].vue"),
    children: [
  {
    name: "wizard-url-recordUUID",
    path: ":recordUUID()",
    meta: _91recordUUID_93NR15fXjM4VjVFP2mfJumCqrIsydPmVkL_f0O9M9FCicMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/wizard/[url]/[recordUUID].vue"),
    children: [
  {
    name: "wizard-url-recordUUID-phase-step-mode",
    path: ":phase?/:step?/:mode?",
    meta: _91_91mode_93_939vXn5BQefP2KcXVaW_NmQvj62WElxzf8Jqftxb6CRzAMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/wizard/[url]/[recordUUID]/[[phase]]/[[step]]/[[mode]].vue")
  }
]
  }
]
  },
  {
    name: "not-authorized",
    path: "/not-authorized",
    component: () => import("/azp/agent/_work/5/s/frontend/pages/not-authorized.vue")
  },
  {
    name: "form-url",
    path: "/form/:url()",
    meta: indexyNDNuWOLhXBczs_sKQNx7Q79Ugorr0QBvQy0yMDlL9kMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/form/[url]/index.vue")
  },
  {
    name: "widgets-analyze-UUID",
    path: "/widgets/analyze/:UUID()",
    meta: _91UUID_935xxhiihFcNw_myS1gkuOtw40HTQPS6_XYYvBIFKrimAMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/widgets/analyze/[UUID].vue")
  },
  {
    name: _91tenantEntryUUID_93BrGfUAe2WnGlAwRltTbChmbsP8MLADO9_FdM1KIHAg8Meta?.name,
    path: "/form/:url()/:tenantEntryUUID()",
    meta: _91tenantEntryUUID_93BrGfUAe2WnGlAwRltTbChmbsP8MLADO9_FdM1KIHAg8Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/form/[url]/[tenantEntryUUID].vue"),
    children: [
  {
    name: "form-url-tenantEntryUUID",
    path: "",
    meta: index9ddaL9pUhZZY1POMNjDkrp2Cd_vkPBjb4_R8Y1P2qw8Meta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/form/[url]/[tenantEntryUUID]/index.vue")
  },
  {
    name: "form-url-tenantEntryUUID-recordUUID",
    path: ":recordUUID()",
    meta: _91recordUUID_93zXiH8_B_AfWNnokNzra3FfY4WH5W0U_Nl5M70cnSQAgMeta || {},
    component: () => import("/azp/agent/_work/5/s/frontend/pages/form/[url]/[tenantEntryUUID]/[recordUUID].vue")
  }
]
  }
]